import { memo, useEffect, useState } from "react";
import { Email } from "./Email";
import { Information } from "./Information";
import { EmailConfirmation } from "./EmailConfirmation";
import { EmailVerification } from "./EmailVerification";
import { PasswordSetup } from "./PasswordSetup";
import * as jose from "jose";
import { AppRoutes, SignupScreens } from "types";
import { useNavigate } from "react-router-dom";
import { Storage, StorageKey } from "lib/storage";

export const SignUp = memo(function SignUp() {
  const navigate = useNavigate();
  const [step, setStep] = useState<SignupScreens>(SignupScreens.Email);
  const [userEmail, setUserEmail] = useState<string>("");

  useEffect(() => {
    try {
      const token = Storage.get(StorageKey.TOKEN);
      if (token) {
        const decoded = jose.decodeJwt(token);
        if (decoded.registered) {
          navigate(AppRoutes.home, { replace: true });
        } else {
          // Extract email from token for use in verification/password steps
          if (decoded.email && typeof decoded.email === "string") {
            setUserEmail(decoded.email);
          }
          setStep(SignupScreens.Information);
        }
      }
    } catch {
      Storage.remove(StorageKey.TOKEN);
      setStep(SignupScreens.Email);
    }
  }, [navigate]);

  switch (step) {
    case SignupScreens.Email:
      return <Email setStep={setStep} setUserEmail={setUserEmail} />;
    case SignupScreens.Information:
      return <Information setStep={setStep} />;
    case SignupScreens.EmailConfirmation:
      return (
        <EmailConfirmation
          email={userEmail}
          setUserEmail={setUserEmail}
          setStep={setStep}
        />
      );
    case SignupScreens.EmailVerification:
      return <EmailVerification email={userEmail} setStep={setStep} />;
    case SignupScreens.PasswordSetup:
      return <PasswordSetup email={userEmail} setStep={setStep} />;
    default:
      return null;
  }
});
